import HighPassFilter from "./HighPassFilter";

export default HighPassFilter;